import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { SIDEBAR_WIDTH } from 'features/app/components/AppSidebar';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    drawer: {
      width: SIDEBAR_WIDTH,
      flexShrink: 0,
    },
    drawerPaper: {
      border: 'unset',
      boxShadow: '13px 3px 40px #00000005',
      width: SIDEBAR_WIDTH,
    },
    drawerHeader: {
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(0, 1),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
      justifyContent: 'flex-end',
    },

    logoContainer: {
      height: 120,
      padding: '27px 51px',
    },
    logo: {},
    listContainer: {
      paddingLeft: 20,
      paddingRight: 29,
    },
  })
);
